import { FundraisingDetail } from '@/models/fundraising-detail.model';
import { FUNDRAISING_ASSETS_BASE_URL } from '@/modules/fundraising-assets/config/fundraising-assets.config';
import { getFundraisingAssets } from '@/modules/fundraising-assets/services/session/fundraising-assets.service';
import { useFundraisingDetailStore } from '@/store/fundraising-detail.store';

export const getFundraisingProject = (): FundraisingDetail => {
  return useFundraisingDetailStore().detail;
};

export const getFundraisingProjectPageTitle = (): string => {
  return getFundraisingProject().title
    ? getFundraisingProject().title
    : 'Project Detail';
};

export const getFundraisingProjectImage = (id: string): string => {
  const project0 = getFundraisingAssets('Project')[0];
  const defaultAsset = project0 ? project0.full : '';
  const asset = getFundraisingAssets('Project').filter(
    (item) => item.uuid === id
  );
  return asset[0]
    ? `${FUNDRAISING_ASSETS_BASE_URL}/${asset[0].full}`
    : `${FUNDRAISING_ASSETS_BASE_URL}/${defaultAsset}`;
};

export const getFundraisingProjectAvatar = (id: string): string => {
  const project8 = getFundraisingAssets('Avatar')[8];
  const defaultAsset = project8 ? project8.full : '';
  const asset = getFundraisingAssets('Avatar').filter(
    (item) => item.uuid === id
  );
  return asset[0]
    ? `${FUNDRAISING_ASSETS_BASE_URL}/${asset[0].full}`
    : `${FUNDRAISING_ASSETS_BASE_URL}/${defaultAsset}`;
};

export const getFundraisingProjectBaseUrl = (affiliate_text: string): string => {
  const environment = window.location.origin.split('.')[0];

  let affiliateText = affiliate_text;
  switch (affiliateText) {
    case 'Canada':
      affiliateText = '.ca';
      break;
    case 'Germany':
      affiliateText = '.de';
          break;
    case 'Spain':
      affiliateText = '.es';
      break;
    case 'France':
      affiliateText = '.fr';
      break;
    case 'Croatia':
      affiliateText = '.hr';
      break;
    case 'Ireland':
      affiliateText = '.ie';
      break;
    case 'Italy':
      affiliateText = '.it';
      break;
    case 'Switzerland':
      affiliateText = '.ch';
      break;
    case 'UK':
      affiliateText = '.org.uk';
      break;
    case 'USA':
      affiliateText = 'usa.org'
          break;
    default:
      affiliateText = '';
  }
  return affiliateText.length > 0
      ? `${environment}.marysmeals${affiliateText}`
      : `${environment}.marysmeals.org`;
}